// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"6596b4ab","453":"cb5d7392","732":"27d58ba2"}[chunkId] + ".chunk.js";
};